module.exports = __webpack_public_path__ + "img/wuwow-jr-logo.8617d424.svg";